import React from 'react';
import { FaInstagram, FaWhatsapp, FaEnvelope } from 'react-icons/fa';
import '../styles/footer.css';
import config from '../config';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <span>© 2026 BadmintonShop.uk</span>
        <div className="footer-email">
          <FaEnvelope className="footer-icon" />
          <a href="mailto:hello@badmintonshop.uk">hello@badmintonshop.uk</a>
        </div>
        <div className="footer-links" style={{ display: 'none' }}>
          <a href="#">Privacy Policy</a>
          <a href="#">Terms</a>
          <FaInstagram className="footer-icon" />
          <a href={`https://wa.me/${config.whatsapp.phoneNumber}?text=${encodeURIComponent(config.whatsapp.defaultMessage)}`} target="_blank" rel="noopener noreferrer" title="Chat on WhatsApp">
            <FaWhatsapp className="footer-icon" />
          </a>
        </div>
      </div>
    </footer>
  );
}